import Message from "./Message.container";

export default Message;
